module.exports = __webpack_public_path__ + "img/31cb1cf.jpg";